module.exports = __webpack_public_path__ + "img/GR.de9a6eb5.png";